var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 18" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M11.2 8.6h-.8V2.9c.7-.1 1.3-.7 1.2-1.5C11.5.7 11 .2 10.4.2H3.6c-.7 0-1.4.6-1.4 1.3 0 .7.6 1.4 1.3 1.4v5.7h-.7C1.4 8.6.3 10 .3 11.7h5.6l.7 6h.7l.8-6h5.5c.1-1.7-1.1-3.1-2.4-3.1zm-5.3 0h-.5V2.9h.5v5.7z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Pinned.svg